module.exports = __webpack_public_path__ + "img/users.fd6361d6.svg";